<div class="verification-container">
  <h2 *ngIf="verified" class="success">✅ Email Verified</h2>
  <h2 *ngIf="error" class="error">❌ Verification Failed</h2>
  <p>{{ message }}</p>

  <a *ngIf="verified" routerLink="/sign-in">Go to Sign In</a>
</div>
